module.exports = __webpack_public_path__ + "media/ca42c10505cb1b22ff965d1b666330f1.ca42c105.mp4";